export const getScoreColor = (score) => {
  if (score < 30) {
    return "#dc2626"; // red
  }

  if (score < 70) {
    return "#f59e0b"; // orange
  }

  return "#15803d"; // green
};
